import { render, staticRenderFns } from "./StudentPersonalProgressPanel.vue?vue&type=template&id=663c15f1&scoped=true&lang=pug&"
import script from "./StudentPersonalProgressPanel.vue?vue&type=script&lang=ts&"
export * from "./StudentPersonalProgressPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPersonalProgressPanel.vue?vue&type=style&index=0&id=663c15f1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c15f1",
  null
  
)

export default component.exports